export enum CancellationReason {
  MISSING_FEATURES = 'missing-features',
  TECHNICAL_ISSUES = 'technical-issues',
  BETTER_ALTERNATIVE = 'better-alternative',
  OTHER = 'other',
}

export const CANCELLATION_REASONS = [
  { value: CancellationReason.MISSING_FEATURES, label: 'Missing features I need' },
  { value: CancellationReason.TECHNICAL_ISSUES, label: 'Technical issues' },
  { value: CancellationReason.BETTER_ALTERNATIVE, label: 'Found a better alternative' },
  { value: CancellationReason.OTHER, label: 'Other' },
]

export enum DeactivateModalStep {
  CONFIRMATION = 'confirmation',
  FEEDBACK = 'feedback',
}

export const NO_OF_FREE_TRIAL_DAYS = 28

// hodor's 28-day timer is one-shot at signup, so orgs already mid-trial keep 14 days.
export const LEGACY_FREE_TRIAL_DAYS = 14

// By this instant every prod hodor task ran the 28-day timer. UTC, like org_created_at.
// CLEANUP: drop this and LEGACY_FREE_TRIAL_DAYS from 2026-10-17. Durable fix: SER-6692.
export const FOUR_WEEK_TRIAL_CUTOFF = '2026-09-18 11:40:00'
